import { render, staticRenderFns } from "./itemUserDetalis.vue?vue&type=template&id=26885854&scoped=true&"
import script from "./itemUserDetalis.vue?vue&type=script&lang=js&"
export * from "./itemUserDetalis.vue?vue&type=script&lang=js&"
import style0 from "./itemUserDetalis.vue?vue&type=style&index=0&id=26885854&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26885854",
  null
  
)

export default component.exports